import { useProductContext } from '../../../context/PlpContext';
import { useExperiencesContext } from '../../experiences/Experiences';
import { useEffect, useState } from 'react';
import { fetchSocialProofData } from '../../../api/social-proof-messaging';

export const useSocialProofData = () => {
  const { products } = useProductContext();

  const [socialProofingMessages, setSocialProofingMessages] = useState({});
  const [previousProdIds, setPreviousProdIds] = useState([]);
  const [availableSocialProofMessages, setAvailableSocialProofMessages] =
    useState([]);

  const getSocialProofingDataPackage = () => {
    return products
      .map((product) => {
        if (previousProdIds.includes(product.id)) {
          return null;
        }

        return {
          productId: product.id,
          brand: product.brand,
          availableToOrder: product.isAvailableToOrder,
        };
      })
      .filter((product) => product !== null);
  };

  const transformSocialProofingResponse = (newSocialProofingMessages) => {
    if (
      newSocialProofingMessages &&
      typeof newSocialProofingMessages === 'object'
    )
      return Object.values(newSocialProofingMessages).reduce((acc, value) => {
        acc[value.productId] = {
          id: value.productId,
          title: value.messages[0]?.title,
        };
        return acc;
      }, {});
  };

  useEffect(() => {
    setPreviousProdIds(products?.map((product) => product.id));
    setAvailableSocialProofMessages(getSocialProofingDataPackage());
  }, [products]);

  useEffect(() => {
    if (availableSocialProofMessages.length == 0) {
      return;
    }
    const fetchedData = async () => {
      try {
        const newSocialProofingMessages = await fetchSocialProofData(
          availableSocialProofMessages
        );
        const transformedMessages = transformSocialProofingResponse(
          newSocialProofingMessages
        );
        setSocialProofingMessages({
          ...socialProofingMessages,
          ...transformedMessages,
        });
        setPreviousProdIds(products?.map((product) => product.id));
      } catch (error) {
        if (process.env.NODE_ENV !== 'development') {
          console.error('Error fetching social proof data: ', error);
        }
      }
    };
    fetchedData();
  }, [availableSocialProofMessages]);

  return { socialProofingMessages };
};
